import { BatteryFull, BatteryLow } from "lucide-react";
import { fmtTimestamp } from "@/lib/format";

// WS101-01 R08 · lectura de batería del botón WS101 en su ficha habitual. Presentación alineada con
// la del botón MOKO (misma columna, mismo tono), PERO con la semántica propia del WS101: pila
// reemplazable, cero literal válido y la ausencia de contacto nunca afirma batería agotada.
export default function BateriaWs101({ lectura, intervalo }) {
  const pct = lectura?.porcentaje;
  const valid = Number.isInteger(pct) && pct >= 0 && pct <= 100;
  const bajo = valid && pct <= 20;
  const Icono = bajo ? BatteryLow : BatteryFull;
  return (
    <div data-testid="ws101-bateria" data-porcentaje={valid ? pct : undefined}
         className="text-xs text-slate-500 mt-1 ml-6 space-y-0.5">
      <p className="flex flex-wrap items-center gap-x-2 gap-y-0.5">
        <span className={`flex items-center gap-1.5 font-medium ${bajo ? "text-[#D97706]" : "text-emerald-600"}`}>
          <Icono strokeWidth={1.75} className="h-3.5 w-3.5" />
          Batería WS101: <span data-testid="ws101-bateria-pct">{valid ? `${pct} %` : "Sin lectura verificada"}</span>
        </span>
        {valid && lectura?.leido_en && (
          <>
            <span aria-hidden>·</span>
            <span data-testid="ws101-bateria-leido">
              Última lectura: <time dateTime={lectura.leido_en}>{fmtTimestamp(lectura.leido_en)}</time>
            </span>
          </>
        )}
      </p>
      <p data-testid="ws101-bateria-intervalo">
        {intervalo ? `Intervalo configurado: ${intervalo} min` : "Intervalo real sin verificar"}
        {lectura?.periodicidad_observada?.intervalos > 0
          ? ` · Recepción observada: mediana ${lectura.periodicidad_observada.mediana_min} min; máximo ${lectura.periodicidad_observada.maximo_min} min.`
          : ""}
      </p>
      <p className="text-slate-400">Pila reemplazable. La falta de contacto no confirma batería agotada.</p>
    </div>
  );
}
